<template>
  <div class="tx-export">
    <md-button type="button" class="tx-export__btn btn md-primary md-yellow" @click="openPopup">
      {{ i18n.th_export_btn() }}
    </md-button>

    <md-dialog :md-backdrop="true"
               :md-active.sync="isPopup"
               class="tx-export-popup__wrap"
    >
      <tx-export-popup @close="closePopup"/>
    </md-dialog>
  </div>
</template>

<script>
import {i18n} from '@js/i18n'
import TxExportPopup from './TxExport.Popup.vue'

export default {
  components: {
    TxExportPopup
  },
  data: () => ({
    i18n,
    isPopup: false
  }),
  methods: {
    openPopup () {
      this.isPopup = true
    },
    closePopup () {
      this.isPopup = false
    }
  },
  destroyed () {
    this.closePopup()
  }
}
</script>



// WEBPACK FOOTER //
// src/vue/app/history/index/components/TxExport.vue